/*
 * @Author: your name
 * @Date: 2021-01-03 19:58:26
 * @LastEditTime: 2021-01-03 19:58:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/vender/form-schema-config/editors/orc-type-config.js
 */
import Vue from 'vue'
import apis from '@/api'

const queryOrcTypeList = () => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_IDENTIFY_TYPE_LIST
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve(resp)
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

export default {
  editorConfigType: 'ORC_TYPE',
  componentName: 'FormConfigOrcTypeConfig',
  configProperty: 'identifyType',
  extras: {
    queryOrcTypeList: queryOrcTypeList
  }
}
